import { FrontpageGraphic } from '@pm2/ui-components';
import { useUserIdentityState } from '@provider/user-identity';
import { resets } from '@ui/css';
import { wrapper, container, backgroundGraphic } from './_portal-page.style.js';
import { FavouritesSection } from './molecule.favourites-section.js';
import { LocationSection } from './molecule.location-section.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FavouritesPortalPage(props) {
  const user = useUserIdentityState(state => state.user);
  if (!user) {
    return null;
  }
  return /*#__PURE__*/jsxs("section", {
    className: wrapper,
    "data-frontpage-top-section": true,
    children: [/*#__PURE__*/jsx("h1", {
      className: resets.screenReaderOnlyCls,
      children: "Brugeromr\xE5de"
    }), /*#__PURE__*/jsxs("div", {
      className: container,
      children: [/*#__PURE__*/jsx(LocationSection, {}), /*#__PURE__*/jsx(FavouritesSection, {})]
    }), /*#__PURE__*/jsx(FrontpageGraphic, {
      className: backgroundGraphic,
      blurredBackgroundImageSrc: props.blurredBackgroundImageSrc
    })]
  });
}

export { FavouritesPortalPage };
//# sourceMappingURL=_portal-page.js.map
